import React from 'react';
import { motion } from 'framer-motion';
import educationImg from '../images/photos/education.gif'; // adjust path if needed

const pageVariants = {
  initial: { rotateY: 90, opacity: 0 },
  in: { rotateY: 0, opacity: 1 },
  out: { rotateY: -90, opacity: 0 }
};

const pageTransition = {
  type: 'spring',
  stiffness: 80,
  damping: 20
};

const Industries_Education = () => (
  <motion.div
    initial="initial"
    animate="in"
    exit="out"
    variants={pageVariants}
    transition={pageTransition}
    style={{
      minHeight: '60vh',
      padding: '20px',
      fontFamily: "Inter, system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial",
      backgroundColor: '#f8fafc',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }}
  >
    {/* Page Heading */}
    <h1
      style={{
        fontSize: '34px',
        marginBottom: '24px',
        textAlign: 'center',
        color: '#1e293b'
      }}
    >
      Education
    </h1>

    <section
      style={{
        maxWidth: '1200px',
        width: '100%',
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: '20px',
        flexDirection: 'row'
      }}
    >
      {/* Left: Image */}
      <div style={{ flex: '1 1 300px', display: 'flex', justifyContent: 'center' }}>
        <img
          src={educationImg}
          alt="Education sector"
          style={{
            width: '100%',
            maxWidth: '500px',
            height: 'auto',
            maxHeight: '400px',
            objectFit: 'contain',
            borderRadius: '12px',
            boxShadow: '0 6px 20px rgba(0,0,0,0.08)'
          }}
        />
      </div>

      {/* Right: Content */}
      <div style={{ flex: '1 1 300px' }}>
        <p style={{ color: '#475569', lineHeight: 1.6 }}>
          At Zyntro Software Solutions Pvt. Ltd., we are committed to revolutionizing the education
          sector with innovative technology solutions. We specialize in providing a wide range of
          educational services, from digital learning platforms and e-learning solutions to data
          management and educational app development. Our goal is to bridge the gap between
          technology and education, creating accessible, engaging, and impactful learning experiences
          for institutions, educators, and students alike.
        </p>
        <p style={{ color: '#475569', lineHeight: 1.6 }}>
          Whether you’re an educational institution looking to enhance your digital presence, or an
          individual seeking tailored learning experiences, we offer customized solutions to meet
          your unique needs. Our team combines expertise in software development, cloud computing,
          and educational consulting to help you deliver high-quality, scalable, and efficient
          learning systems.
        </p>
        <p style={{ color: '#475569', lineHeight: 1.6 }}>
          With Zyntro Software Solutions Pvt. Ltd., you can expect cutting-edge technology that
          empowers educators and students, promotes interactive learning, and ensures a future where
          education is accessible and effective for all.
        </p>
      </div>
    </section>
  </motion.div>
);

export default Industries_Education;
